import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  container: {
    width: '100%',
    overflowX: 'auto',
    marginBottom: 32
  },
  // Condensed layout: a wide table scrolls inside its column instead of widening the page.
  scrollRegion: {
    width: '100%',
    overflowX: 'auto'
  },

  linearProgressRoot: {
    position: 'absolute',
    height: 4,
    width: '100%',
    marginBottom: 0,
    backgroundColor: theme.colors.loading_background
  },

  linearProgressBarColorPrimary: {
    backgroundColor: theme.colors.loading_bar
  },

  header: {
    height: 48
  },
  'dark-tableRowHeaderRoot': {
    borderBottom: `1px solid ${theme.colorPalette.beige_50_op_70}`,
    color: theme.colorPalette.beige_50,
    ...reskinStyles(theme, { borderBottom: 'none', color: theme.colors.text_primary })
  },
  scrollable: {
    height: 630,
    overflow: 'scroll'
  }
});

export default styles;
